<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: student.full_name,
                        href: meta.links.student_show,
                    },
                    {
                        name: subject.name,
                        href: meta.links.subject_tag_scores_index,
                    },
                    {
                        name: block.name,
                        href: null,
                    },
                ]"
            >
                <template v-slot:corner>
                    <div>
                        <ActivityMenuOptions>
                            <InertiaLink
                                v-for="otherStudent in meta.links.otherStudents"
                                :href="otherStudent.url"
                                :key="otherStudent.url"
                                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                role="menuitem"
                            >
                                {{ otherStudent.text }}
                            </InertiaLink>
                        </ActivityMenuOptions>
                    </div>
                </template>
            </SmartBreadcrumbs>
        </template>

        <div>
            <ContentBlockScores :content-block="block" />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import ContentBlockScores from '@/components/ContentBlockScores.vue';
import ActivityMenuOptions from '@/components/pageSpecific/ActivityMenuOptions.vue';

export default {
    components: {
        ActivityMenuOptions,
        PanelPage,
        ContentBlockScores,
    },
    layout: Layout,
    name: 'Show',
    props: ['block', 'subject', 'meta', 'student'],
};
</script>
